import React, { Component } from 'react'
import ButtonAnimated from '../components/buttons/ButtonAnimated'
import StagesManager from '../components/StagesManager'
// import HttpServices from '../utils/Http.services'
// import CollectionStage from './Applets/database/stage/CollectionStage'
// import CollectionType from './Applets/database/stage/CollectionType'
import PermissionsPage from './Applets/PermissionsPage'
// import CAAccess from './CreateApplet/CAAccess'
// import FormBuilder from './FormBuilder'
import CAStageType from './CreateApplet/CAStageType'
import CAMultiStage from './CreateApplet/CAMultiStage'
import { checkConditionGroup, translate } from '../utils/useful'
import CAFrameName from './CreateApplet/CAFrameName'
import CASelectType from './CreateApplet/CASelectType'
import CAMessengerType from './CreateApplet/CAMessengerType'
import CAInquiryType from './CreateApplet/CAInquiryType'
import CAInfo from './CreateApplet/CAInfo'
import CAFormBuilder from './CreateApplet/CAFormBuilder'
import CAReview from './CreateApplet/CAReview'
import CASuccess from './CreateApplet/CASuccess'
import HttpServices from '../utils/Http.services'
import store from '../stores/storeConfig';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import { framesType } from '../variables/framesTypes'
import CFSuccess from './CreateApplet/CFSuccess'


export class CreateFrame extends Component {
    state = {
        data: {
            features: [],
            colors: {
                primaryColor: '#5856d6',
                secondaryColor: '#7c7aff',
                textColor: '#fff'
            },
        },

        baseFrames: [
            {
                name: '{{lang}}Collection', features: ['Collection'], steps: [

                    { id: 'type', to: 'formBuilder' },
                    { id: 'formBuilder', to: 'access' },
                    { id: 'access', to: 'stageType' },
                    { id: 'stageType', to: 'multiStage', condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.type' }, operator: { value: '==' }, target: { value: 'multi' } } } } },
                    { id: 'stageType', to: "review", condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.type' }, operator: { value: '==' }, target: { value: 'single' } } } } },
                    { id: 'multiStage', to: 'review' },
                    // { id: 'userPrespective', to: 'review' },

                ],
                frames: [{ id: "collection", key: "collection", pageType: 'collection' }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/database.png'
            },
            {
                name: '{{lang}}ca.Tasking', features: ['Tasking'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'multiStage' },
                    { id: 'multiStage', to: 'review' },

                ],
                frames: [{ id: "collection", key: "frame", pageType: 'collection', name: "Default tasks" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/tasking.png'
            },

            {
                name: '{{lang}}Related hubs', features: ['relations'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'review' },

                ],

                frames: [{ id: "relations", key: "frame", pageType: 'collection', name: "Related hubs" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/tasking.png'
            },


            {
                name: '{{lang}}ca.Tasking', features: ['Project'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'multiStage' },
                    { id: 'multiStage', to: 'review' },

                ],
                frames: [{ id: "collection", key: "frame", pageType: 'collection', name: "Default tasks" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/tasking.png'
            },
            {
                name: '{{lang}}ca.TaskList', features: ['TaskList'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'multiStage' },
                    { id: 'multiStage', to: 'review' },

                ],
                frames: [{ id: "collection", key: "frame", pageType: 'collection', name: "TaskList" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/tasking.png'
            },
            {
                name: '{{lang}}ca.Planner', features: ['Planner'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'multiStage' },
                    { id: 'multiStage', to: 'review' },

                ],
                frames: [{ id: "collection", key: "frame", pageType: 'collection', name: "Planner" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/tasking.png'
            },
            {
                name: '{{lang}}ca.Sprints', features: ['recordClassifier'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'multiStage' },
                    { id: 'multiStage', to: 'review' },

                ],
                frames: [{ id: "collection", key: "frame", pageType: 'collection', name: "Sprints" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/tasking.png'
            },
            {
                name: '{{lang}}ca.Messenger', features: ['Messenger'], steps: [

                    { id: 'type', to: 'messengerType' },
                    { id: 'messengerType', to: 'access' },
                    { id: 'access', to: 'stageType' },
                    { id: 'access', to: 'review' },

                ],
                frames: [{ id: "collection", key: "collection", pageType: 'messenger', name: "Default messenger" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/portals/chat (2).png'
            },
            {
                name: '{{lang}}ca.Finance', features: ['Finance'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'review' },

                ],
                frames: [],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/finance.png'
            },
            {
                name: '{{lang}}ca.Commerce', features: ['Commerce'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'userPrespective' },
                    { id: 'userPrespective', to: 'review' },

                ],
                frames: [],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/commerce.png'
            },
            // { name: '{{lang}}ca.Commissions', features: ['Commissions'], steps: [], description: '{{lang}}This is the description of this applet type', icon: '/images/man.svg' },
            {
                name: '{{lang}}ca.Booking', features: ['Booking'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'userPrespective' },
                    { id: 'userPrespective', to: 'review' },

                ],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/booking.png'
            },

            {
                name: '{{lang}}ca.Inquiry', features: ['Inquiry'], steps: [

                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'stageType' },
                    // { id: 'userPrespective', to: 'review' },
                    { id: 'stageType', to: 'multiStage', condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.type' }, operator: { value: '==' }, target: { value: 'multi' } } } } },
                    { id: 'stageType', to: "review", condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.type' }, operator: { value: '==' }, target: { value: 'single' } } } } },
                    { id: 'multiStage', to: 'review' },

                ],
                frames: [{ id: "collection", key: "frame", pageType: 'collection', name: "Inquiry" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/inquiry.png'
            },
            {
                name: '{{lang}}ca.Drive', features: ['Drive'], steps: [
                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'review' },
                    // { id: 'userPrespective', to: 'review' },
                ], description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/drive.png',
                frames: [{ id: "collection", key: "collection", pageType: 'drive', name: "Default drive" }],

            },
            {
                name: '{{lang}}Calendar', features: ['Calendar'], steps: [
                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'review' },
                ], frames: [{ id: "collection", key: "collection", pageType: 'calendar', name: "Default calendar" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/notebook.png'
            },
            {
                name: '{{lang}}Developers', features: ['Developer'], steps: [
                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'review' },
                ], frames: [{ id: "collection", key: "collection", pageType: 'collection', name: "Untitled collection" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/notebook.png'
            },
            {
                name: '{{lang}}Rooms', features: ['Rooms'], steps: [
                    { id: 'type', to: 'access' },
                    { id: 'access', to: 'review' },
                ], frames: [{ id: "collection", key: "collection", pageType: 'rooms', name: "Untitled collection" }],
                description: '{{lang}}This is the description of this applet type', icon: '/assets/icons/applets/notebook.png'
            },

        ],
    }

    componentDidMount() {

        let newData = this.state.data
        newData.features = this.props.applet.features
        this.setState({ data: newData })

        let params = this.props.windowData?.params

        if (params?.type) {

            let type = params.type
            let id = params.parent

            if (id) {
                let data = this.state.data
                data.collection = id
                data.mode = 'relevant'
                this.setState({ data })
            }

            this.setCurrentFrameTemplate(params?.type, params?.mode)


            // if (this.props.applet.features[0] == 'Inquiry') {
            //     this.stageManager.changeStage('collectionType')
            // }

            // else {
            //     this.stageManager.changeStage('newform')
            // }

            if (this.props.setHeader) {

                // this.props.setHeader({
                //     'toolbar': null,
                //     'showToolbar': false,
                //     topHeaderComponent: this.topHeaderComponent,
                //     backAction: () => this.stageManager.lastStage()

                // })
            }

        }
        // console.log('collectionBuilder', this.props)
    }




    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    title='Next'
                    icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }



    onSave = (rawData, frameName) => {
        if (rawData && frameName.trim()) {
            let data = this.state.data
            data.frame = rawData
            data.name = frameName
            data.type = 'collection'
            data.applet = this.props.variables.appletId
            // console.log('this.props.variables.applet', this.props.variables.appletId)
            this.setState({ data }, () => {
                this.stageManager.changeStage('collectionType')
                // this.props.setHeader({
                // })
                // this.stageManager.changeStage('collectionPermissions')
                // HttpServices.request('postFrame', data, (fetchResult, fetchError) => {
                //     if (fetchError)setData {
                //         return
                //     }
                //     // this.props.lastStagePage()

                // })
            })
        }
    }
    onSavePermissions = (data, cb) => {
        let newData = this.state.data

        if (!newData) {
            newData = {}
        }


        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }

        this.setState({ data: newData }, () => {
            if (cb) { cb() }
            this.postFrame()
        })
    }


    setData = (data, cb, refKey) => {
        let mainKey = refKey ?? 'data'
        let newData = this.state[mainKey]

        if (!newData) {
            newData = {}
        }

        // console.log('newData', newData)
        // console.log('nData', data)
        for (const [key, value] of Object.entries(data)) {
            // console.log('key', key)
            // console.log('value', value)
            newData[key] = value
        }

        this.setState({ [mainKey]: newData }, () => {
            if (cb) { cb() }
        })
    }

    // setData = (key, value, reference, cb) => {
    //     // console.log('setDatalll')
    //     if (reference == 'CollectionBuilder') {
    //         // console.log('eer')
    //         this.setState({ [key]: value }, () => {
    //             if (cb) {
    //                 // console.log('tp2222')
    //                 cb()
    //             }
    //         })
    //     }
    //     else {
    //         // console.log('refff', reference)
    //         if (this.props.setData) {
    //             this.props.setData(key, value, reference, () => {

    //             })
    //         }
    //     }
    // }
    postFrame = (cb) => {
        if (this.props.postFrame) {
            this.props.postFrame(this.state.data, cb)
        }
        // console.log('this.state.data', this.state.data)
        // // return
        // HttpServices.request('postFrame', this.state.data, (fecthResult, fetchError) => {
        //     cb()
        //     if (fetchError) {
        //         return
        //     }
        //     if (fecthResult) {
        //         // this.props.setData('modules', this.state.data, 'BaseAdminView')
        //         console.log('postFrameFetchresult', fecthResult)
        //         let path = this.props.windowData.path
        //         let newPath = [path[0], path[1], path[2]]
        //         // this.props.changeWindowLink(newPath)
        //         this.props.changeWindow(newPath)
        //     }
        //     //TO DO

        // })
    }

    // postFrame = (cb) => {
    //     console.log('this.state.data', this.state.data)
    //     // return
    //     HttpServices.request('postFrame', this.state.data, (fecthResult, fetchError) => {
    //         cb()
    //         if (fetchError) {
    //             return
    //         }
    //         if (fecthResult) {
    //             // this.props.setData('modules', this.state.data, 'BaseAdminView')
    //             console.log('postFrameFetchresult', fecthResult)
    //             let path = this.props.windowData.path
    //             let newPath = [path[0], path[1], path[2]]
    //             // this.props.changeWindowLink(newPath)
    //             this.props.changeWindow(newPath)
    //         }
    //         //TO DO

    //     })
    // }
    // nextStage = () => {
    //     this.stageManager.nextStage()
    //     // this.stageManager.changeStage(stage)
    // }


    setCurrentFrameTemplate = (type, mode, cb) => {

        let frame

        let baseFrames = this.state.baseFrames
        if (mode) {

            baseFrames.forEach(myFrame => {

                if (myFrame.features[0].toLowerCase() == mode.toLowerCase()) {
                    frame = myFrame
                }
            })
        }
        if (!frame) {

            baseFrames.forEach(myFrame => {

                if (myFrame.features[0].toLowerCase() == type.toLowerCase()) {
                    frame = myFrame
                }
            });
        }


        // let hub = this.state.data?.hub
        // let features = this.state.data?.features
        if (frame) {

            let data = { frames: frame.frames, name: this.state.data?.name }

            if (frame.config) {
                Object.entries(frame.config).map(([key, value]) => {
                    data[key] = value
                })
            }

            console.log("data", data)

            this.setState({ data }, () => {
                this.setState({ currentFrameTemplate: frame }, () => {

                })
            })

        } else {
            console.log('notValid')
            this.stageManager.changeStage("notValid")
        }
    }



    continue = (currentStage) => {

        let currentFrameTemplate = this.state.currentFrameTemplate
        let data = this.state.data
        if (currentFrameTemplate) {

            let steps = currentFrameTemplate.steps
            let nextStep

            if (steps) {

                steps.forEach(step => {

                    if (step.id == currentStage && (!step.condition || checkConditionGroup(step.condition, { data }))) {
                        nextStep = step.to
                    }
                })
            }

            if (nextStep) {
                this.stageManager.changeStage(nextStep)
            }
        }


    }


    setFrameFields = (fields, index = 0, cb) => {

        let data = this.state.data
        if (Array.isArray(data.frames)) {
            data.frames[index].fields = fields
        }

        this.setState({ data }, () => {
            cb()
        })
    }




    showHeader = (prop, cb) => {
        this.setState({ show: prop }, () => {
            if (cb) {
                cb()
            }
        })
    }



    createFrame = (cb) => {

        // console.log("createFrame")

        let data = this.state.data
        data.applet = this.props.applet?._id ?? this.props.applet
        // console.log('this,ddd', this.props.windowData.params.type)
        data.type = this.props.windowData.params.type
        data.mode = this.props.windowData.params.mode
        data.parent = this.props.windowData.params.parent
        // console.log('dataCF', data)
        // return
        // let info = framesType[this.state.currentFrameTemplate.features[0].toLowerCase()]
        // console.log('info.addUrl', info.addUrl)
        // console.log("postFrame", data)
        HttpServices.request('postFrame', data, (fetchResult, fetchError) => {

            // console.log('fetchError', fetchError, fetchResult)

            if (fetchError) {
                cb(false, fetchError.message)
                return
            }
            // console.log('fetchResultcf', fetchResult)
            if (fetchResult.info) {

                // let connections = fetchResult.connections

                // if (!Array.isArray(connections)) {
                //     connections = [connections]
                // }
                // // console.log('connections', fetchResult)
                // store.dispatch(actions.appendConnection(connections))
                // console.log("HERE")
                setTimeout(() => {
                    this.props.updateFrames()
                }, 100);

                // let result = fetchResult.info
                // if (!Array.isArray(result)) {
                //     result = [result]
                // }
                // result.map((frame) => {
                //     this.setData(frame)
                //     if (this.props.updateFrames) {
                //         // console.log('framesiop[p', frame)
                //         this.props.updateFrames(frame)
                //     }
                // })
                // if (this.props.setData && fetchResult.permissions) {
                //     this.props.setData('permissions', fetchResult.permissions, 'Applet')
                // }



                this.stageManager.changeStage('success')

                let createdFrame = fetchResult.info

                if (Array.isArray(createdFrame)) {
                    createdFrame = createdFrame[0]
                }

                this.setState({ createdFrame })
            }


        })
    }


    // visitApplet = () => {
    //     let appId = this.state.data?.slug ?? this.state.data?.urlcode
    //     this.props.changeWindow('applet', { path: [this.state.hubInfo?.username, appId] })
    // }


    render() {

        let colors = this.props.colors ?? this.state.colors

        return (
            <div className='h-100 w-100 scroll-no-scrollbar' >

                <StagesManager height={'100%'} ref={el => this.stageManager = el} >

                    <CAFrameName stage={0} stageName={'init'} preTitle={translate('Create Frame')} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} changePage={this.props.changePage} secCustomHeaderKey={'collectionInfo.collectionName'} />

                    {/* <FormBuilder stage={1} user={this.props.user} modules={this.props.modules} stageName={'formBuilder'} baseUrl={this.props.baseUrl} type={'newform'} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.props.page} initData={this.state.data.frame} collectionName={this.state.data.name} data={this.state.data} onSave={this.onSave} setData={this.setData} saveTitle='Next Step' applet={this.props.applet} pages={this.props?.pages} width={this.props.width} variables={this.props.variables} height={this.props.height} changePage={this.props.changePage} title={"newform"} description={"Manage things and applets"} route={this.props.route} variables={this.props.variables} functionsHandler={this.props.functionsHandler} lastStagePage={this.props.lastStagePage} /> */}
                    <CAFormBuilder stage={10} stageName={'formBuilder'} preTitle={translate('Create Frame')} continue={this.continue} setFrameFields={this.setFrameFields} showHeader={this.showHeader} setHeader={this.props.setHeader} lastStage={this.lastStage} colors={colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} bgColor={this.state.bgColor} />

                    {/* <CAStageType stage={10} stageName={'formType'} preTitle={translate('Create Frame')}  continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} colors={colors} lastStage={this.lastStage} initData={this.state.data} user={this.props.user} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} />
                    <CAMultiStage stage={10} stageName={'multiStage'} preTitle={translate('Create Frame')}  continue={this.continue} frames={this.state.data?.frames} showHeader={this.showHeader} setHeader={this.props.setHeader} colors={colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} saveTitle='Next' /> */}

                    {/* <CollectionType stageName={'collectionType'} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.props.page} initData={this.state.data} submitCollection={this.submitCollection} collectionName={this.state.data.name} data={this.state.data} onSave={this.onSave} setData={this.setData} changeStage={this.changeStage} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.props?.pages} width={100} height={this.props.height} type={'collectionType'} stage={1} user={this.props.user} modules={this.props.modules} changePage={this.props.changePage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={this.props.variables} functionsHandler={this.props.functionsHandler} />
                    <CollectionStage baseUrl={this.props.baseUrl} stageName={'collectionstage'} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} initData={this.state.data} page={this.props.page} submitCollection={this.submitCollection} data={this.state.data} setData={this.setData} changeStage={this.changeStage} lastStagePage={this.props.lastStagePage} saveTitle='submit' applet={this.props.applet} pages={this.props?.pages} width={100} height={this.props.height} type={'collectionstage'} stage={1} user={this.props.user} modules={this.props.modules} changePage={this.changeStage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={this.props.variables} functionsHandler={this.functionsHandler} /> */}
                    {/* <CollectionPermissions baseUrl={this.props.baseUrl} type={'collectionPermissions'} initData={this.state.data} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.props.page} submitCollection={this.submitCollection} data={this.state.data} setData={this.setData} changeStage={this.changeStage} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.props?.pages} width={100} height={this.props.height} stage={1} user={this.props.user} modules={this.props.modules} stageName={'collectionPermissions'} changePage={this.changeStage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={this.props.variables} functionsHandler={this.functionsHandler} /> */}
                    {/* <PermissionsPage baseUrl={this.props.baseUrl} postFrame={this.postFrame} type={'collectionPermissions'} initData={this.state.data} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.props.page} submitCollection={this.submitCollection} data={this.state.data} setData={this.setData} changeStage={this.changeStage} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.props?.pages} width={100} height={this.props.height} stage={1} user={this.props.user} modules={this.props.modules} stageName={'collectionPermissions'} changePage={this.changeStage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={this.props.variables} functionsHandler={this.functionsHandler} /> */}
                    {/* <CAAccess hideHeader={true} baseUrl={this.props.baseUrl} type={'collectionPermissions'} initData={this.state.data} language={this.props.language} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} page={this.props.page} submitCollection={this.submitCollection} data={this.state.data} setData={this.onSavePermissions} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.props?.pages} width={100} height={this.props.height} stage={1} user={this.props.user} modules={this.props.modules} stageName={'collectionPermissions'} changePage={this.changeStage} title={"Manage"} description={"Manage things and applets"} route={this.props.route} variables={this.props.variables} functionsHandler={this.functionsHandler} /> */}
                    <CASelectType stage={1} stageName={'type'} preTitle={translate('Create Frame')} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} bgColor={this.state.bgColor} baseApplets={this.state.baseApplets} setCurrentAppletTemplate={this.setCurrentAppletTemplate} />
                    <CAMessengerType stage={10} stageName={'messengerType'} preTitle={translate('Create Frame')} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} colors={colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} />
                    <CAInquiryType stage={10} stageName={'inquiryType'} preTitle={translate('Create Frame')} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} colors={colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} />
                    <PermissionsPage stage={10} stageName={'access'} preTitle={translate('Create Frame')} continue={this.continue} frames={this.state.data?.frames} showHeader={this.showHeader} setHeader={this.props.setHeader} lastStage={this.lastStage} user={this.props.user} colors={colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} forApplet={false} />

                    <CAStageType stage={10} stageName={'stageType'} preTitle={translate('Create Frame')} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} colors={colors} lastStage={this.lastStage} initData={this.state.data} user={this.props.user} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} />
                    <CAMultiStage stage={10} stageName={'multiStage'} hideMore={true} preTitle={translate('Create Frame')} continue={this.continue} frames={this.state.data?.frames} showHeader={this.showHeader} setHeader={this.props.setHeader} colors={colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} variables={this.props.variables} saveTitle='Next' />

                    <CAReview stage={2} stageName={'review'} preTitle={translate('Create Frame')} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} user={this.props.user} initData={this.state.data} colors={this.state.colors} language={this.props.settings?.language} setData={this.setData} createApplet={this.createApplet} createFrame={this.createFrame} width={this.props.width} variables={this.props.variables} forApplet={false} currentFrameTemplate={this.state.currentFrameTemplate} />

                    <CFSuccess stage={4} stageName={'success'} createdFrame={this.state.createdFrame} preTitle={translate('Create Frame')} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} visitHub={this.visitHub} changeWindow={this.props.changeWindow} width={this.props.width} variables={this.props.variables} />

                    {/* <CAAccess stage={10} stageName={'access'} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} /> */}
                    {/* <UserPrespective stage={10} stageName={'userPrespective'} preTitle={Translation('Create Frame')}  continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} lastStage={this.lastStage} user={this.props.user} colors={colors} initData={this.state.data} language={this.props.settings?.language} setData={this.setData} width={this.props.width} forApplet={true} /> */}
                    {/* <CAInfo stage={2} stageName={'info'} continue={this.continue} showHeader={this.showHeader} setHeader={this.props.setHeader} user={this.props.user} initData={this.state.data} colors={colors} language={this.props.settings?.language} setData={this.setData} createApplet={this.createApplet} width={this.props.width} /> */}

                </StagesManager>

            </div>
        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateFrame);
